import { SignIn, useAuth } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import { Button } from "~/components/ui/button";
import { useHandleStudioAuth } from "~/hooks/use-handle-studio-auth";

export const Route = createFileRoute("/(auth)/studio-auth/")({
  component: RouteComponent,
  validateSearch: (search) => {
    const targetOrigin = z.string().url().parse(search.targetOrigin);

    return {
      targetOrigin,
    };
  },
});

function RouteComponent() {
  const auth = useAuth();

  const { targetOrigin } = Route.useSearch();

  const { postTokenToWindow } = useHandleStudioAuth();

  useEffect(() => {
    if (auth.isSignedIn) {
      postTokenToWindow(window.opener, targetOrigin);
    }
  }, [auth.isSignedIn, targetOrigin]);

  if (auth.isSignedIn) {
    // Notify user they are signed in. The close button must close the window
    // and focus the `window.opener` object.
    return (
      <div className="flex flex-col items-center justify-center h-screen mx-auto gap-2">
        <h1 className="text-2xl font-bold">You are signed in!</h1>
        <p className="text-sm text-gray-500">You can close this window now.</p>
        <Button
          className="mt-2"
          variant="outline"
          size="sm"
          onClick={() => {
            window.opener?.focus();
            window.close();
          }}
        >
          Return to Studio
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen mx-auto gap-2">
      <SignIn
        withSignUp={false}
        transferable={false}
        forceRedirectUrl={`/studio-auth?targetOrigin=${targetOrigin}`}
      />
    </div>
  );
}
